import { useEffect } from "react";
import { useAppDispatch } from "app/store/hook";
import { getWeather } from "app/reducers/weatherSlice";

const TEN_MINUTES = 10 * 60 * 1000;

/** 로그인 상태에서 즉시 1회, 이후 10분마다, 탭이 다시 보일 때 날씨를 갱신한다(스펙 §4.3). */
export function useWeatherRefresh(enabled: boolean) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!enabled) return;
    dispatch(getWeather());
    const timer = window.setInterval(() => dispatch(getWeather()), TEN_MINUTES);
    const onVisible = () => { if (document.visibilityState === "visible") dispatch(getWeather()); };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [enabled, dispatch]);
}
